// Non-essential (marketing/analytics) third-party scripts. These must only be loaded
// after the user accepts cookies via the CookieConsentBanner, per EU ePrivacy/GDPR rules
// on strictly-necessary vs. non-essential cookies.

const HEAP_APP_ID = '2116327147';
const FB_PIXEL_ID = '513347769357368';

let loaded = false;

const loadHeap = () => {
    window.heap = window.heap || [];
    window.heap.load = function (e, t) {
        window.heap.appid = e;
        window.heap.config = t = t || {};
        var r = document.createElement("script");
        r.type = "text/javascript";
        r.async = true;
        r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js";
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(r, a);
        for (var n = function (e) {
            return function () {
                window.heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
        }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], o = 0; o < p.length; o++) {
            window.heap[p[o]] = n(p[o]);
        }
    };
    window.heap.load(HEAP_APP_ID);
};

const loadFullStory = () => {
    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
    window['_fs_org'] = 'G3TMN';
    window['_fs_namespace'] = 'FS';
    (function (m, n, e, t, l, o, g, y) {
        if (e in m) { if (m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'); } return; }
        g = m[e] = function (a, b, s) { g.q ? g.q.push([a, b, s]) : g._api(a, b, s); }; g.q = [];
        o = n.createElement(t); o.async = 1; o.crossOrigin = 'anonymous'; o.src = 'https://' + window._fs_script;
        y = n.getElementsByTagName(t)[0]; y.parentNode.insertBefore(o, y);
        g.identify = function (i, v, s) { g(l, { uid: i }, s); if (v) g(l, v, s) }; g.setUserVars = function (v, s) { g(l, v, s) }; g.event = function (i, v, s) { g('event', { n: i, p: v }, s) };
        g.anonymize = function () { g.identify(!!0) };
        g.shutdown = function () { g("rec", !1) }; g.restart = function () { g("rec", !0) };
        g.log = function (a, b) { g("log", [a, b]) };
        g.consent = function (a) { g("consent", !arguments.length || a) };
        g.identifyAccount = function (i, v) { o = 'account'; v = v || {}; v.acctId = i; g(o, v) };
        g.clearUserCookie = function () { };
        g.setVars = function (n, p) { g('setVars', [n, p]); };
        g._w = {}; y = 'XMLHttpRequest'; g._w[y] = m[y]; y = 'fetch'; g._w[y] = m[y];
        if (m[y]) m[y] = function () { return g._w[y].apply(this, arguments) };
        g._v = "1.3.0";
    })(window, document, window['_fs_namespace'], 'script', 'user');
};

const loadHubSpot = () => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js.hs-scripts.com/21088451.js';
    document.head.appendChild(script);
};

const loadFacebookPixel = () => {
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = true; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = true;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', FB_PIXEL_ID);
    window.fbq('track', 'PageView');
};

// Idempotent: safe to call multiple times (e.g. once on mount for a returning
// consented user, and again if they interact with the banner in the same session).
export const loadTrackingScripts = () => {
    if (loaded) return;
    loaded = true;

    loadHeap();
    loadFullStory();
    loadHubSpot();
    loadFacebookPixel();
};
